// Consistent section header: a mono "channel" eyebrow (index + label) that
// reads like a register on an instrument panel, then a display title.
const SectionHeading = ({ index, eyebrow, title, accent, children }) => (
  <div className="max-w-2xl">
    <div className="eyebrow mb-4">
      <span className="idx">[ {index} ]</span> {eyebrow}
    </div>
    <h2 className="font-display text-4xl md:text-5xl font-bold text-fg tracking-tight">
      {title} {accent && <span className="text-signal">{accent}</span>}
    </h2>
    {children && <p className="mt-5 text-lg text-fg-dim leading-relaxed">{children}</p>}
  </div>
);

export default SectionHeading;
